/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backend_Session_LabelInputs */

const en_backend_session_label = /** @type {(inputs: Backend_Session_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RMF backend session`)
};

const fr_backend_session_label = /** @type {(inputs: Backend_Session_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session backend RMF`)
};

const ms_sg2_backend_session_label = /** @type {(inputs: Backend_Session_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi backend RMF`)
};

/**
* | output |
* | --- |
* | "RMF backend session" |
*
* @param {Backend_Session_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const backend_session_label = /** @type {((inputs?: Backend_Session_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backend_Session_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backend_session_label(inputs)
	if (locale === "fr") return fr_backend_session_label(inputs)
	return ms_sg2_backend_session_label(inputs)
});